import React from 'react'

import Layout from '../layouts/en'
import SEO from '../components/seo'
import Sliders from '../components/Sliders'
import Bubble from '../components/Bubble'
import BubbleOutline from '../components/BubbleOutline'
import IntroBox from '../components/IntroBox'
import IllustrationBox from '../components/IllustrationBox'
import Testimonial from '../components/Testimonial'
import FlickitySlider from '../components/FlickitySlider'

const Schools = require('../data/Schools')
const CollegeAchievements = require('../data/CollegeAchievements')

const IndexPage = (props) => (
  <Layout location={props.location}>
    <SEO title="Home" />

    <Sliders lang="en" />

    <div className="container py-8">
      <div className="flex flex-row flex-wrap -mx-2 mb-8">
        <div className="box-p65 w-full lg:w-1/3 xl:w-1/2 mb-4">
          <div className="mx-2 absolute inset-0">
            <img src="/AnnualReport2017-2018/images/home/image01.png" alt="IFT" className="object-cover object-bottom h-full w-full" />
          </div>
        </div>

        <div className="w-full lg:w-2/3 xl:w-1/2">
          <Bubble className="mx-2 mb-4"
            title="League of Elite"
            subtitle="Embrace the Present and Face Future Challenges"
          >
            <div className="text-sm md:text-base leading-relaxed text-justify">
              <p className="mb-4">Institute for Tourism Studies (IFT), established in 1995, is a public institution of higher education under the governance of the Secretary for Social Affairs and Culture of the Macao Special Administrative Region Government, offering a wide range of tourism related undergraduate programmes and professional training, which include areas in hospitality, tourism business, heritage, events, retail and marketing, leisure and entertainment, sports and recreation, creative and cultural studies, and culinary arts.</p>
              <p>Tourism College and Tourism and Hotel School are the 2 major components of IFT. They offer four-year bachelor’s degree programmes and professional training courses respectively.</p>
            </div>
          </Bubble>
        </div>
      </div>

      <div className="flex flex-row flex-wrap -mx-2">
        {
          Schools.map((school, i) => (
            <div key={i} className="w-full md:w-1/2 mb-8 flex" data-aos={`${i == 0 ? 'fade-right' : 'fade-left'}`}>
              <IntroBox className="mx-2 text-sm md:text-base h-full"
                title={school.title['en']}
                more
                link={`/${school.link['en']}`}
                image={school.image}
              >
                {school.description['en']}
              </IntroBox>
            </div>
          ))
        }
      </div>
    </div>

    <div className="bg-cover bg-no-repeat bg-cover bg-center pt-8 lg:pt-12 xl:pt-24 mb-12"
      style={{ backgroundImage: "url('/AnnualReport2017-2018/images/home/bg-slogan.jpg')" }}
    >
      <div className="container">
        <div className="flex flex-row -mx-2">
          <BubbleOutline className="w-full md:w-3/4 mx-2 mb-12 text-justify"
            title="President's Message"
            more
            link="/presidents-message"
          >
            <div data-aos="fade-up">
              Institute for Tourism Studies is based in Macao and looks to the international community to enhance the international competitiveness of the Institute by continuously improving the quality of teaching and research. We are committed to expanding our partnerships with educational institutions, tourism organizations and research institutions around the world to expand our international network.
            </div>
          </BubbleOutline>

          <div className="hidden md:block self-end w-1/5 md:w-1/4 mx-2">
            <img src="/AnnualReport2017-2018/images/home/principal.png" alt="President" />
          </div>
        </div>
      </div>
    </div>

    <div className="container">
      <h2 className="text-yellow-500 text-3xl text-center mb-12">Teaching quality is well received</h2>

      <div className="flex flex-row flex-wrap -mx-8 md:mb-12">
        {
          CollegeAchievements.illustrationItems.map((item, i) => (
            <div key={i} className="w-1/2 md:w-1/4 mb-12" data-aos="fade-up" data-aos-delay={i * 200}>
              <div className="mx-8">
                <IllustrationBox
                  number={item.number}
                  image={item.image}
                  title={item.title['en']}
                  text={item.text['en']}
                  className="text-3xl"
                />
              </div>
            </div>
          ))
        }
      </div>

      <FlickitySlider className="mb-12">
        {
          CollegeAchievements.listItems.map((item, i) => (
            <div key={i} className="w-full md:w-1/2 p-4">
              <Testimonial
                title={item.title['en']}
                color={item.color}
              >
                {
                  item.content['en'].map((text, j) => (
                    <p key={j} className="mb-4">
                      { text }
                    </p>
                  ))
                }
              </Testimonial>
            </div>
          ))
        }
      </FlickitySlider>
    </div>
  </Layout>
)

export default IndexPage
